import React from "react";
import NavBar from "../components/NavBar";

const TrainsEscapeTermsPage = ({ language, onLanguageChange, t }) => {
  const thirdPartyProviders = t("trainsTerms.thirdParty.providers") || [];

  return (
    <div className="page foody-page trains-page support-page" id="trains-terms-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/trainsescape", label: t("trainsTerms.nav.back") },
          { href: "/apps/trainsescape/static/support", label: t("trainsTerms.nav.support") },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("trainsTerms.badge")}</span>
            <h1>{t("trainsTerms.hero.title")}</h1>
            <p>{t("trainsTerms.hero.desc")}</p>
            <p className="support-muted">{t("trainsTerms.hero.effectiveDate")}</p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("trainsTerms.acceptance.title")}</h3>
              <p>{t("trainsTerms.acceptance.p1")}</p>
              <p>{t("trainsTerms.acceptance.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.intellectualProperty.title")}</h3>
              <p>{t("trainsTerms.intellectualProperty.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.serviceChanges.title")}</h3>
              <p>{t("trainsTerms.serviceChanges.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.deviceSecurity.title")}</h3>
              <p>{t("trainsTerms.deviceSecurity.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.thirdParty.title")}</h3>
              <p>{t("trainsTerms.thirdParty.desc")}</p>
              <ul className="support-list">
                {thirdPartyProviders.map((provider) => (
                  <li key={provider.name}>
                    <a href={provider.url} target="_blank" rel="noopener noreferrer">
                      {provider.name}
                    </a>
                  </li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.connectivity.title")}</h3>
              <p>{t("trainsTerms.connectivity.p1")}</p>
              <p>{t("trainsTerms.connectivity.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.liability.title")}</h3>
              <p>{t("trainsTerms.liability.p1")}</p>
              <p>{t("trainsTerms.liability.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.updates.title")}</h3>
              <p>{t("trainsTerms.updates.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsTerms.changes.title")}</h3>
              <p>{t("trainsTerms.changes.desc")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("trainsTerms.contact.title")}</h2>
            <p>
              {t("trainsTerms.contact.desc")}
              <br />
              <a href="mailto:support-trainsescape@wodaslabs.com">
                support-trainsescape@wodaslabs.com
              </a>
            </p>
          </div>
          <div className="store-badges foody-store-badges">
            <a className="btn primary" href="/apps/trainsescape/static/support">
              {t("trainsTerms.contact.cta")}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TrainsEscapeTermsPage;
